import { RuntimeAppConfig } from '@/_types/app-config.model';
import { EnvType, EnvTypeConfig } from '@/_types/enums/envType.enum';

import { environment } from './environment';

const CONFIG_URL = 'assets/config.json';

/** Apply runtime config over build-time defaults. Exported for unit tests. */
export function applyRuntimeConfig(config: RuntimeAppConfig): void {
  if (config.production !== undefined) {
    environment.production = config.production;
  }

  if (config.envType !== undefined) {
    environment.envType = new EnvTypeConfig(config.envType as EnvType.TYPE);
  }

  if (config.NovatiqAPIKey !== undefined) {
    environment.NovatiqAPIKey = config.NovatiqAPIKey;
  }

  if (config.NovatiqAPIURL !== undefined) {
    environment.NovatiqAPIURL = config.NovatiqAPIURL;
  }

  if (config.NovatiqEncryptionKey !== undefined) {
    environment.NovatiqEncryptionKey = config.NovatiqEncryptionKey;
  }

  if (config.supersetAPIURL !== undefined) {
    environment.supersetAPIURL = config.supersetAPIURL;
  }

  if (config.useMockAttributesApi !== undefined) {
    environment.useMockAttributesApi = config.useMockAttributesApi;
  }
}

/** Fetch runtime config before Angular bootstraps. Missing/invalid config keeps environment.ts defaults. */
export async function loadAppConfig(): Promise<void> {
  try {
    const response = await fetch(CONFIG_URL, { cache: 'no-store' });
    if (!response.ok) {
      return;
    }

    const config = (await response.json()) as RuntimeAppConfig;
    applyRuntimeConfig(config);
  } catch {
    // ponytail: no config.json — local dev uses environment.ts defaults
  }
}
